<template>
  <NormalHeaderLayout :header="getTabName()">
    <div class="container ptl-20">
      <Notification v-if="showMessage()" :notification="getMessage()" />
      <ExperimentalNotification
        v-if="showExperimentalMessage"
      ></ExperimentalNotification>
      <Spinner v-if="loading || (resultExist && !widgetSpecReady)"></Spinner>
      <div
        class="search-result"
        v-if="searchQuery && resultExist && widgetSpecReady"
      >
        <Result :tabId="tabId"></Result>
      </div>
    </div>
  </NormalHeaderLayout>
</template>
<script>
import { mapGetters } from 'vuex';
import Result from '../components/search/Result.vue';
import Spinner from '../components/ui/Spinner.vue';
import i18n from '../i18n';
import Notification from '../components/Notification.vue';
import ExperimentalNotification from '../components/search/ExperimentalNotification.vue';
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout.vue';

export default {
  data() {
    return {
      searchQuery: '',
      message: {},
      widgetSpecReady: false,
      tabId: '',
      experimentalMessage: {},
    };
  },
  computed: {
    ...mapGetters(['loading', 'resultExist', 'currentTab']),
    locale() {
      return i18n.locale;
    },
    showExperimentalMessage() {
      return this.$route.name === 'apnic-experimental';
    },
  },
  watch: {
    locale() {},
    $route() {
      this.tabId = this.$route.name;
      this.startSearch();
    },
  },
  mounted() {
    this.tabId = this.$route.name;
    this.startSearch();
    this.checkWidgetSpec();
  },
  methods: {
    checkWidgetSpec() {
      if (window.STAT_WIDGETS_SPEC) {
        this.widgetSpecReady = true;
      } else {
        setTimeout(() => this.checkWidgetSpec(), 500);
      }
    },
    showMessage() {
      return window.location.hash && window.location.hash.includes('index');
    },

    getMessage() {
      try {
        let hashes = this.$route.hash.split('#');
        if (hashes && hashes.length > 1) {
          let params = hashes[1].split('&').map((i) => i.split('='));
          if (params) {
            params = Object.assign(
              {},
              ...params.map((x) => ({ [x[0]]: x[1] }))
            );
            if (params.category && params.index) {
              return {
                summary:
                  this.$tc('welcomePage.exampleTitle', 1) +
                  ' ' +
                  this.$route.params.pathMatch +
                  ' ' +
                  this.$tc('welcomePage.exampleTitle', 2),
                content: this.$t('welcomePage.' + params.category + '.items')[
                  params.index
                ].example.split('|'),
              };
            }
          }
        }
      } catch (e) {
        return {};
      }
      return {};
    },
    getTabName() {
      if (!this.tabId) return '';
      return this.$t('tabs')[this.tabId].name;
    },
    startSearch() {
      this.searchQuery = this.$route.params.pathMatch;
      this.$store.dispatch('searchResource', this.searchQuery);
    },
  },
  components: {
    Result,
    Spinner,
    Notification,
    NormalHeaderLayout,
    ExperimentalNotification,
  },
};
</script>
<style scoped lang="scss">
.sb1 div {
  margin: 0 auto;
}
.ptl-20 {
  padding-top: 20px;
  padding-left: 20px;
}
.header-container {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  &__left {
    padding-left: 20px;
    h1 {
      font-size: 24px;
      line-height: 60px;
      margin-bottom: 0px;

      @media screen and (max-width: 485px) {
        font-size: 24px;
        line-height: 60px;
        margin-bottom: 0;
      }
    }
  }
}
</style>
